import { render, staticRenderFns } from "./ServiceChargeManaged.vue?vue&type=template&id=47ed602a&scoped=true&"
import script from "./ServiceChargeManaged.vue?vue&type=script&lang=js&"
export * from "./ServiceChargeManaged.vue?vue&type=script&lang=js&"
import style0 from "./ServiceChargeManaged.vue?vue&type=style&index=0&id=47ed602a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed602a",
  null
  
)

export default component.exports